module.exports = "/images/vessel-7.jpg";